export const Logo = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="BHOLEBOOK trident cricket logo"
  >
    <defs>
      <linearGradient id="bb-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FFF099" />
        <stop offset="55%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#996515" />
      </linearGradient>
    </defs>
    {/* trident shaft */}
    <rect x="30" y="22" width="4" height="36" rx="1.5" fill="url(#bb-gold)" />
    {/* trident prongs */}
    <path
      d="M18 22 L18 6 L22 10 L22 22 Z M30 22 L30 2 L34 2 L34 22 Z M42 22 L42 10 L46 6 L46 22 Z"
      fill="url(#bb-gold)"
    />
    <path d="M14 22 h36 v3 h-36 z" fill="url(#bb-gold)" />
    {/* crossed bats */}
    <rect
      x="8"
      y="38"
      width="28"
      height="4"
      rx="1"
      transform="rotate(32 8 38)"
      fill="url(#bb-gold)"
      opacity="0.9"
    />
    <rect
      x="28"
      y="38"
      width="28"
      height="4"
      rx="1"
      transform="rotate(-32 56 38)"
      fill="url(#bb-gold)"
      opacity="0.9"
    />
    {/* seam ball */}
    <circle cx="32" cy="54" r="6" fill="#09090D" stroke="url(#bb-gold)" strokeWidth="1.5" />
    <path d="M27 54 h10" stroke="#D4AF37" strokeWidth="0.8" strokeDasharray="1.2 1.2" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <Logo size={36} />
    <div className="leading-none">
      <div className="font-display text-2xl font-black tracking-wide gold-text">
        BHOLEBOOK
      </div>
      <div className="font-mono-stat text-[10px] uppercase tracking-[0.2em] text-amber-400/80">
        24x7 India's Best Book
      </div>
    </div>
  </div>
);
